module.exports = __webpack_public_path__ + "static/media/players-stats@3x.76f2d155.png";